import { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
const POST_PER_PAGE = 10;
const PaginationComp = ({
  pageMaxNo,
  active,
  history,
  isAdmin = false,
  urlBeforePageNo, //admin과 user property로 구성된 object
}) => {
  const [activePage, setActivePage] = useState(active);
  const [standardPage, setStandardPage] = useState(1);
  const [paginationList, setPaginationList] = useState([]);

  const onClickPage = (number) => {
    if (isAdmin) {
      // history.push(`/admin/board/qna?pageNo=${number}`);
      history.push(`${urlBeforePageNo.admin}${number}`);
    } else {
      // history.push(`/dashboard/qna?pageNo=${number}`);
      history.push(`${urlBeforePageNo.user}${number}`);
    }
    setActivePage(number);
  };
  useEffect(() => {
    setPaginationList([]);
    let items = [];
    let endPageNum =
      standardPage * 10 < pageMaxNo ? standardPage * 10 : pageMaxNo;
    for (let i = (standardPage - 1) * 10 + 1; i <= endPageNum; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === parseInt(activePage)}
          onClick={() => onClickPage(i)}
          // href={`/dashboard/qna?pageNo=${i}`}
        >
          {i}
        </Pagination.Item>
      );
    }
    setPaginationList(items);
  }, [standardPage, activePage]);
  useEffect(() => {
    setStandardPage(Math.ceil(active / 10));
    setActivePage(active);
  }, [active]);
  //0. 총 게시물의 갯수 : n
  //1. 몇개의 게시물씩 보여줄지: 10
  //2. 그 중 몇번째 페이지인지: i
  console.log(`pageMaxNo: ${pageMaxNo}\nactive: ${active}`);

  return (
    <div>
      <Pagination style={{ justifyContent: "center" }}>
        <Pagination.Item
          onClick={() => {
            setStandardPage(standardPage - 1 > 0 ? standardPage - 1 : 1);
          }}
        >
          ⇦
        </Pagination.Item>
        {paginationList}
        <Pagination.Item
          onClick={() => {
            let flag = standardPage * 10 < pageMaxNo ? true : false;
            if (flag) setStandardPage(standardPage + 1);
            else setStandardPage(standardPage);
          }}
        >
          ⇨
        </Pagination.Item>
      </Pagination>
    </div>
  );
};
export default PaginationComp;
